import { useMemo } from 'react';
import moment from 'moment';
import { getEta } from 'app/utils/utils';
import { GetMapSingleResponse } from 'ais-facade-api/api';
import { useFormatMoment } from './useFormatMoment';

export const useGetDestinationInfo = (vessel: GetMapSingleResponse | undefined) => {
  const formatMoment = useFormatMoment();
  const destination = useMemo(() => vessel?.result?.voyage?.destination, [vessel]);
  const calculatedETA = useMemo(
    () =>
      vessel?.result?.voyage?.predictedEta !== undefined ? formatMoment(moment(vessel.result.voyage.predictedEta)) : undefined,
    [vessel, formatMoment],
  );

  const eta: string | undefined = useMemo(() => {
    if (!vessel?.result?.voyage?.eta || Object.keys(vessel.result.voyage.eta).length === 0) return;
    if (vessel.result.voyage.eta.dt) return formatMoment(moment(vessel.result.voyage.eta.dt));
    return getEta(vessel.result.voyage.eta);
  }, [vessel?.result?.voyage?.eta, formatMoment]);

  const departureTime = useMemo(
    () => (vessel?.result?.departurePort?.dt !== undefined ? formatMoment(moment(vessel.result.departurePort.dt)) : undefined),
    [vessel, formatMoment],
  );

  const departurePortName = useMemo(() => vessel?.result?.departurePort?.port?.name, [vessel]);
  const departurePortKey = useMemo(() => vessel?.result?.departurePort?.port?.key, [vessel]);
  const departurePortCode = useMemo(() => vessel?.result?.departurePort?.port?.countryCode, [vessel]);

  return { eta, destination, calculatedETA, departureTime, departurePortName, departurePortKey, departurePortCode };
};
